import Image from 'next/image';
import { formatCurrency } from '../../libs/formatters';
import { getModelByCode } from '../../models/dtos/Model';
import { Brand, Car } from '../../data/schema';

type Props = {
	car: Car;
	brand?: Brand;
};

const CarCard = ({ car, brand }: Props) => {
	//const model = getModelByCode(car.model!);

	let image = `/images/under-construction.png`;

	if (car.raw?.image) {
		image = car.raw.image;
	}

	return (
		<div
			key={car.id}
			className="flex overflow-hidden shadow-lg rounded-lg h-90 w-60 md:w-80 cursor-pointer m-auto bg-white dark:bg-gray-700 mb-7">
			<a href="#" className="w-full block h-full">
				<Image
					src={image}
					className="max-h-30 w-full object-cover bg-white"
					alt={car.name}
					title={car.name}
					width={150}
					height={80}
					layout="responsive"
				/>
				{/*<img
						alt="blog photo"
						src="https://www.tailwind-kit.com/images/blog/1.jpg"
						className="max-h-40 w-full object-cover"
					/>*/}
				<div className="w-full p-4">
					<p className="text-green-700 text-md font-medium">
						{brand ? brand.name : ''} <span className="text-xs">{/*model ? model.name : ''*/}</span>
					</p>
					<p className="text-gray-800 dark:text-white text-xl font-medium mb-2">{car.name}</p>
					{/*<p className="text-gray-400 dark:text-gray-300 font-light text-md">
							The new supercar is here, 543 cv and 140 000$. This is best racing GT about 7 years
							on...
				</p>*/}
					<div className="flex flex-wrap justify-starts items-center mt-4">
						{/*<div className="text-xs mr-2 py-1.5 px-4 text-gray-600 bg-blue-100 rounded-2xl">
								#Car
			</div>*/}
						<div className="text-xs mr-2 py-1.5 px-4 text-gray-600 bg-green-100 rounded-2xl">
							{formatCurrency(car.price)}
						</div>
					</div>
				</div>
			</a>
		</div>
	);
};

export default CarCard;
